import React from 'react';

import DrawerCDS from 'app/shared/componentsRestyled/coreDesignSystem/Drawer/DrawerCDS/DrawerCDS';
import _ from 'lodash';
import PropTypes from 'prop-types';

import { VendorRequestsTestIds } from '../vendorRequests.testIds';

import { getDrawerTitle } from './VendorRequestDetailDrawer.utils';
import VendorRequestDrawerBody from './VendorRequestDrawerBody';

const VendorRequestDetailDrawer = ({ applicationId, group = null, onClose }) => {
  const isOpen = !_.isNil(group);
  const groupKey = _.get(group, 'groupKey');

  return (
    <DrawerCDS
      content={
        isOpen && (
          <VendorRequestDrawerBody applicationId={applicationId} group={group} key={groupKey} />
        )
      }
      data-testid={VendorRequestsTestIds.DETAIL_DRAWER}
      open={isOpen}
      title={isOpen ? getDrawerTitle(group) : ''}
      onClose={onClose}
    />
  );
};

VendorRequestDetailDrawer.propTypes = {
  applicationId: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  group: PropTypes.shape({
    groupKey: PropTypes.string,
    requestType: PropTypes.string,
    vendorName: PropTypes.string,
    status: PropTypes.string,
    correlationId: PropTypes.string,
    itemCount: PropTypes.number,
  }),
};

export default VendorRequestDetailDrawer;
